import { formatPercentage, isDefined } from "@pharmupp/p3-front-commons"
import {
  LoyaltyProgramCard,
  type LoyaltyProgramCardProps,
} from "../../../LoyaltyProgram"

export const ChequeCashingRateCard = ({
  value,
  ...props
}: Omit<LoyaltyProgramCardProps, "value"> & { value?: number | null }) => {
  return (
    <LoyaltyProgramCard
      {...props}
      value={
        isDefined(value)
          ? formatPercentage(value, { maximumFractionDigits: 1 })
          : "-"
      }
      slotProps={{
        Title: { fontWeight: 600 },
        Subtitle: { variant: "16px" },
        Card: {
          sx: (theme) => ({ background: theme.palette.common.periwinkleBlue }),
        },
      }}
    />
  )
}
